import { enum_ } from "valibot"

export enum MouseButton {
  PRIMARY = 0,     // Left click (or right click for left-handed users)
  AUXILIARY = 1,   // Middle/wheel click
  SECONDARY = 2,   // Right click (or left click for left-handed users)
  BACK = 3,        // Browser back button (if present)
  FORWARD = 4      // Browser forward button (if present)
}

export const MouseButtonSchema = enum_(MouseButton)
